import create from 'zustand'
import { persist } from 'zustand/middleware'
import { WhiteLabelStore } from './types'

export const useWhiteLabelStore = create<WhiteLabelStore>()(
  persist(
    set => {
      return {
        whiteLabelClinicId: null,
        setWhiteLabelClinicId: (id: string) => {
          set({
            whiteLabelClinicId: id,
          })
        },
        uniqueCode: '',
        setUniqueCode: (code: string) => {
          set({
            uniqueCode: code,
          })
        },
      }
    },
    {
      name: 'whiteLabel',
      getStorage: () => sessionStorage,
    },
  ),
)
